import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueScrollTo from 'vue-scrollto'
import VueFullPage from 'vue-fullpage.js'
// import lax from 'lax.js'
import BootstrapVue from 'bootstrap-vue'
import vueScrollwatch from "vue-scrollwatch"
import $ from 'jquery' 

require("expose-loader?$!jquery"); 
window.$ = $;

Vue.use(VueFullPage)
Vue.use(BootstrapVue)
Vue.use(vueScrollwatch)

Vue.config.productionTip = false

Vue.mixin({
	methods: {
		payrocio () {
			window.$MPC.openCheckout({
				// rocio
				url:"https://www.mercadopago.com/mla/checkout/start?pref_id=387712604-f3015e07-fcbe-410d-8c6b-cffefc575115"
				// onreturn: data => { retorna data si usuario cancela la operacion // console.log(data) // eslint-disable-line // }
			})
		},
		paymanteca () {
			window.$MPC.openCheckout({
				// rocio
				url: "https://www.mercadopago.com/mlc/checkout/pay?pref_id=387712604-f96b5709-08e5-4fe9-a98e-96a5447ca9b2"
				// onreturn: data => { retorna data si usuario cancela la operacion // console.log(data) // eslint-disable-line // }
			})
		}
	}
})
 
// manteca
// url: "https://www.mercadopago.com/mlc/checkout/pay?pref_id=387712604-f96b5709-08e5-4fe9-a98e-96a5447ca9b2"

Vue.use(VueScrollTo, {
	container: "body",
	duration: 750,
	easing: "ease",
	offset: 0,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true
 })


//
//
//

$(window).scroll(function() {
	
		var scroll = $(window).scrollTop();
	// isActive .footer-bar
	if (scroll > 36) {

		$('.site-header').addClass('site-header-scroll');
		$('.site-header-space').addClass('isActive');
	}

	if(scroll < 36){
		$('.site-header').removeClass('site-header-scroll');
		$('.site-header-space').removeClass('isActive');
	}

	if(scroll > 750){
		$('.footer-bar').addClass('isActive');
	}else{
		$('.footer-bar').removeClass('isActive');
	}
	if(scroll > 4500){
		$('.footer-bar').removeClass('isActive');
	}


});

new Vue({
	router,

	created() {
		// window.fbAsyncInit = function() {FB.init({ xfbml:true, version:'v3.2'});};
		return (function(d, s, id) { var js, fjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) return; js = d.createElement(s); js.id = id; js.src = 'https://connect.facebook.net/es_LA/sdk/xfbml.customerchat.js'; fjs.parentNode.insertBefore(js, fjs); }(document, 'script', 'facebook-jssdk'));

	},
	render: h => h(App)
}).$mount('#app')